var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInforec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#364584"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8444 7.98418L14.6913 9.17407V7.53169C14.6913 7.3539 14.6193 7.18339 14.4911 7.05767C14.3629 6.93196 14.1891 6.86133 14.0078 6.86133H7.85627C7.49371 6.86133 7.14601 7.00258 6.88965 7.25402C6.63328 7.50545 6.48926 7.84647 6.48926 8.20205V13.5649C6.48926 13.9205 6.63328 14.2615 6.88965 14.513C7.14601 14.7644 7.49371 14.9057 7.85627 14.9057H14.0078C14.1891 14.9057 14.3629 14.835 14.4911 14.7093C14.6193 14.5836 14.6913 14.4131 14.6913 14.2353V12.5862L16.8444 13.7761C16.8996 13.8115 16.9634 13.832 17.0292 13.8356C17.0951 13.8392 17.1608 13.8257 17.2197 13.7964C17.2786 13.7672 17.3286 13.7233 17.3647 13.6692C17.4008 13.615 17.4217 13.5525 17.4253 13.4878V8.26909C17.4211 8.20476 17.3998 8.14264 17.3635 8.08892C17.3271 8.0352 17.2771 7.99176 17.2183 7.96294C17.1595 7.93411 17.0941 7.9209 17.0284 7.92463C16.9628 7.92836 16.8994 7.94889 16.8444 7.98418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInforec);
export default __webpack_public_path__ + "static/media/inforec.5c3d70af56910634abfb29b9899dc757.svg";
export { ForwardRef as ReactComponent };